exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text_privacy p[data-v-f79c6344] {\n\twidth: 100%;\n\theight: 100%;\n\ttext-indent: 4ch;\n}\n.text_privacy[data-v-f79c6344] {\n\tpadding: 20px;\n}\n", ""]);

// exports
